import { Img } from "@/components/image";

export const DiscountImage = ({
  image,
}: {
  image: string | React.ReactNode;
}) => {
  if (image === "amount") {
    return <DiscountIconWrapper>$</DiscountIconWrapper>;
  }
  if (image === "percentage") {
    return <DiscountIconWrapper>%</DiscountIconWrapper>;
  }
  if (image === null) {
    return null;
  }

  return <Img alt="" height={48} src={image as string} width={48} />;
};

const DiscountIconWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex h-full w-full flex-1 items-center justify-center rounded-[6px] bg-brand-grey4 font-medium text-xl">
      {children}
    </div>
  );
};
